var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwoTicks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 12,
    viewBox: "0 0 19 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2589 0.578402L17.6427 0.0988315C17.4392 -0.0610254 17.1428 -0.023241 16.9858 0.180213L10.08 9.0421C9.94339 9.22521 9.68761 9.26299 9.50451 9.12639C9.48707 9.11476 9.46963 9.10023 9.4551 9.08279L8.99296 8.66425C8.83311 8.50149 8.57443 8.49858 8.41166 8.65553C8.39713 8.67007 8.3826 8.68751 8.36807 8.70495L7.87978 9.32693C7.72283 9.53911 7.74027 9.83557 7.92628 10.0245L9.62948 11.6579C9.78934 11.8207 10.048 11.8236 10.2108 11.6638C10.2253 11.6492 10.2398 11.6318 10.2544 11.6143L18.3431 1.23818C18.5001 1.03181 18.4623 0.738259 18.2589 0.578402ZM12.9719 0.578402L12.3558 0.0988315C12.1523 -0.0610254 11.8559 -0.023241 11.6989 0.180213L4.79309 9.0421C4.65648 9.22521 4.40071 9.26299 4.2176 9.12639C4.20016 9.11476 4.18272 9.10023 4.16819 9.08279L1.34308 6.32162C1.15707 6.14142 0.860605 6.14433 0.680403 6.33034L0.133983 6.88548C-0.0462193 7.0715 -0.0433128 7.36796 0.142703 7.54816L4.34258 11.655C4.50244 11.8178 4.76111 11.8207 4.92388 11.6608C4.93841 11.6463 4.95294 11.6289 4.96748 11.6114L13.0533 1.23818C13.2132 1.03181 13.1754 0.738259 12.9719 0.578402Z",
    fill: "#53BDEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoTicks);
export default __webpack_public_path__ + "static/media/two-ticks.6914ff17c3574a89778456c8f5d68d20.svg";
export { ForwardRef as ReactComponent };